import { render } from "./myHead.vue?vue&type=template&id=147e03cc&scoped=true&ts=true"
import script from "./myHead.vue?vue&type=script&lang=ts"
export * from "./myHead.vue?vue&type=script&lang=ts"

import "./myHead.vue?vue&type=style&index=0&id=147e03cc&lang=less&scoped=true"

import exportComponent from "E:\\pc\\saas-pc\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-147e03cc"]])

export default __exports__